import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TraceServiceImprovement } from 'app/trace-management/core/services/trace-improvement.service';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'biz-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent {
  public selectedCategory: string;
  public selectedSource: string;
  public fileNameFilter: string;
  public showMessage: boolean = false;
  public disabledCreationDate: boolean = true;
  public disabledModificationDate: boolean = true;

  public dateMinCreation: Date = new Date();
  public dateMaxCreation: Date = new Date();
  public dateMinModified: Date = new Date();
  public dateMaxModified: Date = new Date();

  public sources: Array<string> = [];
  public categories: Array<string> = [];

  public isCollapsed: boolean = false;

  @Input() showLoading: boolean = false;
  @Input() itemsPerPage: number = 20;

  @Output() emitFilter: EventEmitter<ITraceFilterManagement> = new EventEmitter<ITraceFilterManagement>();
  @Output() emitIsCollapse: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private _traceService: TraceServiceImprovement, private _i18nService: I18nService) {
  }

  ngOnInit() {
    this._traceService.getCategories().subscribe((data: any) => {
      this.sources = data.Applications;
      this.selectedSource = 'All'; // TODO: While is defined the correlation between sources and categories
      this.upperCategories(data.Categories);
    });
  }

  upperCategories(categories) {
    this.categories = categories.map(category => {
      if (category.toLowerCase() === 'ecm') return 'ECM';
      if (category.toLowerCase() === 'rpa') return 'RPA';
      return category;
    });
  }

  filterFileTraces(event, option) {
    if (option === 0) {
      this.dateMinCreation = event.start;
      this.dateMaxCreation = event.end;
    } else {
      this.dateMinModified = event.start;
      this.dateMaxModified = event.end;
    }
  }

  getFormattedDate(date, sufix) {
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const formattedDate = `${year}${month}${day}${sufix}`;
    return formattedDate;
  }

  getFilesNames() {
    this.trimFilterName();
    let traceFilter: ITraceFilterManagement = {
      Category: this.fixCategory(),
      Application: this.selectedSource,
      FileName: this.fileNameFilter,
      Created_From: this.getFormattedDate(this.dateMinCreation, '0000'),
      Created_To: this.getFormattedDate(this.dateMaxCreation, '2359'),
      Modified_From: this.getFormattedDate(this.dateMinModified, '0000'),
      Modified_To: this.getFormattedDate(this.dateMaxModified, '2359'),
      PageSize: this.itemsPerPage,
      PageNumber: 0
    }

    if (this.disabledModificationDate) {
      traceFilter.Modified_From = null;
      traceFilter.Modified_To = null;
    }

    if (this.disabledCreationDate) {
      traceFilter.Created_From = null;
      traceFilter.Created_To = null;
    }

    this.emitFilter.emit(traceFilter);
  }

  fixCategory() {
    let categoryToSend = this.selectedCategory;
    if (categoryToSend === 'ECM')
      categoryToSend = 'Ecm';
    if (categoryToSend === 'RPA')
      categoryToSend = 'Rpa';
    return categoryToSend;
  }

  trimFilterName() {
    if (this.fileNameFilter && this.fileNameFilter.length > 0)
      this.fileNameFilter = this.fileNameFilter.trim();
    return this.fileNameFilter;
  }

  disabledButton() {
    let desibledBtn = true;
    if (this.selectedCategory && this.selectedSource)
      desibledBtn = false;
    return desibledBtn || this.showLoading;
  }

  collapse() {
    this.isCollapsed = !this.isCollapsed;
    this.emitIsCollapse.emit(this.isCollapsed);
  }
}
